import React from 'react';
import { useTranslation } from 'react-i18next';

import { TGatewayHealthChipProps } from '@/console/features/gateways/components/gateway-health-chip/gateway-health-chip.types';
import { useGatewayHealth } from '@/console/features/gateways/hooks/use-gateway-health/use-gateway-health';
import { GatewayIcon } from '@/shared/assets/icons/gateway-icon';
import { Chip } from '@/shared/components/ui/chip/chip';
import { ChipStatus } from '@/shared/components/ui/chip/chip.types';
import { useEnumLabel } from '@/shared/hooks/use-enum-label/use-enum-label';
import { GatewayStateEnum } from '@/shared/types/types.generated';

export const GatewayHealthChip: React.FC<TGatewayHealthChipProps> = ({
  gatewayId,
  gatewayName,
  descriptiveTooltip,
}) => {
  const { t } = useTranslation();
  const { getEnumLabel } = useEnumLabel();
  const { state } = useGatewayHealth(gatewayId);

  const getChipColor = (): ChipStatus => {
    switch (state) {
      case GatewayStateEnum.Online:
        return 'green';
      case GatewayStateEnum.Offline:
        return 'red';
      default:
        return 'grey';
    }
  };

  const getTooltip = () => {
    const prefix = gatewayName ? `${gatewayName}: ` : '';
    const gatewayHealthState = getEnumLabel(
      state ?? GatewayStateEnum.Offline,
      'gateways:gateway_state',
    );

    if (descriptiveTooltip) {
      return `${prefix}${t('gateways:gateway_health')}: ${gatewayHealthState}`;
    }

    return `${prefix}${gatewayHealthState}`;
  };

  return (
    <Chip
      status={getChipColor()}
      label={<GatewayIcon />}
      tooltip={getTooltip()}
    />
  );
};
